import { FormControl } from '@mui/material';
import { DatePicker, DatePickerProps } from '@sm-dashboard/ui-components';
import dayjs from 'dayjs';
import { Controller, useFormContext } from 'react-hook-form';
import { formatFormDate, parseDateFormValue } from '../utils/dateValue';

type InputDateProps = Omit<DatePickerProps, 'value' | 'onChange'> & {
  name: string;
  label?: string;
  defaultValue?: string;
  disabled?: boolean;
  helperText?: string;
  /** When unset, storage type follows the current field value (string, Dayjs, or Date). */
  saveAsString?: boolean;
}

export const InputDate = ({
  name,
  label,
  defaultValue,
  disabled,
  helperText,
  saveAsString,
  ...props
}: InputDateProps) => {
  const { control } = useFormContext() || {};

  const emitChange = (value: unknown, date: Date | null, onChange: (next: unknown) => void) => {
    if (saveAsString === true) {
      onChange(formatFormDate(date) ?? '');
      return;
    }
    if (saveAsString === false) {
      onChange(date ? dayjs(date) : null);
      return;
    }
    if (value == null || value === '') {
      onChange(formatFormDate(date) ?? '');
      return;
    }
    if (dayjs.isDayjs(value)) {
      onChange(date ? dayjs(date) : null);
      return;
    }
    if (value instanceof Date) {
      onChange(date);
      return;
    }
    onChange(formatFormDate(date) ?? '');
  };

  return (
    <FormControl fullWidth>
      <Controller
        name={name}
        control={control}
        render={({ field: { onChange, value }, fieldState: { error } }) => (
          <DatePicker
            label={label || ''}
            value={parseDateFormValue(value, defaultValue)}
            onChange={date => emitChange(value, date, onChange)}
            disabled={disabled}
            error={!!error}
            helperText={error?.message || helperText}
            {...props}
          />
        )}
      />
    </FormControl>
  );
};

export default InputDate;
